import React, { useEffect, useState } from 'react';
import AssignAdvisorModal from './AssignAdvisorModal';
import type { Notify } from './AssignAdvisorModal';
import { canAssignAdvisor } from './advisors';
import { fetch_me as fetchMe } from '../../sales_team/api';
import type { SalesMe } from '../../sales_team/api';
import { SHARED_STYLES } from '../styles';

interface Props {
  studentUuid: string;
  studentName: string;
  isSuperUser: boolean;
  notify: Notify;
  // Reload the host after an assign / 409 so the new advisor shows.
  onDone: () => void;
}

// "Assign advisor" on a profile whose sales_advisor is null; SUPER_USER or can_edit_team only.
function AssignAdvisorControl({ studentUuid, studentName, isSuperUser, notify, onDone }: Props) {
  const [me, setMe] = useState<SalesMe | null>(null);
  const [open, setOpen] = useState(false);

  // SUPER_USER needs no /me; others are gated on can_edit_team (a failed /me hides the button).
  useEffect(() => {
    if (isSuperUser) return undefined;
    let live = true;
    fetchMe()
      .then((m) => live && setMe(m))
      .catch(() => live && setMe(null));
    return () => {
      live = false;
    };
  }, [isSuperUser]);

  if (!canAssignAdvisor(isSuperUser, me)) return null;
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="rounded-md px-3 py-1.5 text-xs font-medium"
        style={SHARED_STYLES.SECONDARY_BTN}
      >
        Assign advisor
      </button>
      <AssignAdvisorModal
        student={open ? { uuid: studentUuid, name: studentName } : null}
        notify={notify}
        onClose={() => setOpen(false)}
        onDone={onDone}
      />
    </>
  );
}

export default AssignAdvisorControl;
